import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
let tokenGetter = null;
export const setTokenGetter = (g) => { tokenGetter = g; };
api.interceptors.request.use(async (c) => {
  if (tokenGetter) {
    const t = await tokenGetter();
    if (t) c.headers.Authorization = `Bearer ${t}`;
  }
  return c;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Request failed";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d.message || JSON.stringify(d);
};

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString() : "—");
export const fmtDT = (v) => (v ? new Date(v).toLocaleString() : "—");
export const fmtLeft = (s) => {
  if (s == null) return "—";
  if (s <= 0) return "Expired";
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  return d ? `${d}d ${h}h` : `${h}h ${m}m`;
};
export const lim = (v) => (v === null || v === undefined ? "Not set" : v === 0 ? "Disabled" : v.toLocaleString());
